import actions from '../../actionTypes';

export default tag => {
  return {
    type: actions.UPDATE_TAG,
    tag
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/updateTag.js